module.exports = __webpack_public_path__ + "static/media/user-add.804229bd.svg";